import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import verify from "../../../assets/images/verify.png";
import { expertPurchasePackage } from '../../../services/userpackage';


function ExpertPaymentSuccess() {
  const params = useParams();
  const packageId = params.packageId;
  const licenses = params.licenses;
  const couponId = params.couponId;
  // Set when the server could not confirm the payment after a few tries.
  const [notConfirmed, setNotConfirmed] = useState(false);
  useEffect(() => {
    packagePurchase(1);
  }, []);
  // Licenses are granted only once Stripe confirms the payment, which can lag the redirect back
  // here by a few seconds. Try a few times before saying so. The server also grants from Stripe's
  // own notification, so licenses still arrive if this page gives up or is closed.
  const packagePurchase = async (attempt) => {
    try {
      const res = await expertPurchasePackage(packageId, licenses, couponId);
      if (res.data.data) {
        window.setTimeout(function () {
          window.location.replace("/expert/packages");
        }, 3000);
      } else if (attempt < 4) {
        window.setTimeout(function () { packagePurchase(attempt + 1); }, 3000);
      } else {
        setNotConfirmed(true);
      }
    } catch (error) {
      window.location.replace("/expert/packages");
    }
  };

  return (
    <>
          <div className="app-main flex-column flex-row-fluid " id="kt_app_main">
            <div className="d-flex flex-column flex-column-fluid">
              <div id="kt_app_toolbar" className="app-toolbar  py-3 py-lg-6 ">

                <div id="kt_app_toolbar_container" className="app-container  container-xxl d-flex flex-stack ">



                  <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3 ">

                  </div>

                </div>
              </div>

              <div id="kt_app_content" className="app-content  flex-column-fluid " >


                <div id="kt_app_content_container" className="app-container  container-xxl ">
                  <div className="row g-5 g-xl-10 mb-80">
                    <div className="col">

                      <div className="card card-flush h-md-100">
                        <div className="card-body pt-7">
                          <h3 className="card-title align-items-start flex-column text-center">
                            <img src={verify} className="h-60px h-lg-75px" />
                            <h1 className="card-label fw-bold text-gray-800 fs-35 mt-10">Thank You</h1>
                            <h1 className="card-label fw-bold text-gray-800">for Purchasing Package.</h1>
                            {notConfirmed ?
                              <p className="fs-5 text-gray-700 mt-6">We have not been able to confirm your payment yet.
                                Your licenses will be added as soon as it clears. If they have not appeared within a few
                                minutes, please contact support@vertivio.com.</p>
                            : <></>}
                          </h3>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            </div>
    </>
  );
}

export default ExpertPaymentSuccess;